export default __webpack_public_path__ + "static/media/partner-15.0b03c725.png";